module.exports = __webpack_public_path__ + "static/media/bloo-icon-white.6d634ed6.svg";